module.exports = __webpack_public_path__ + "img/lex.8bf42c4c.png";